'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _commentary_card = require('./commentary_card.js');

var _commentary_card2 = _interopRequireDefault(_commentary_card);

var _performance_card = require('./performance_card.js');

var _performance_card2 = _interopRequireDefault(_performance_card);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _audio_commentary = require('./content_components/audio_commentary');

var _functional_utility = require('common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundCommentary = function (_React$PureComponent) {
  _inherits(FundCommentary, _React$PureComponent);

  function FundCommentary() {
    _classCallCheck(this, FundCommentary);

    return _possibleConstructorReturn(this, (FundCommentary.__proto__ || Object.getPrototypeOf(FundCommentary)).apply(this, arguments));
  }

  _createClass(FundCommentary, [{
    key: 'render',
    value: function render() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.fund.shareClass.htmlCommentaries)) {
        return null;
      }
      var audioCommentary = (0, _functional_utility.pathOrNull)(["fund", "fundContent", "audioCommentary"], this.props);

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12', 'data-testid': 'commentary-content' },
        !(0, _functional_utility.isNilOrEmpty)(audioCommentary) && _react2.default.createElement(_audio_commentary.AudioCommentary, {
          audioCommentary: audioCommentary
        }),
        _react2.default.createElement(_commentary_card2.default, { htmlCommentaries: this.props.fund.shareClass.htmlCommentaries,
          disclosures: this.props.fund.disclosures }),
        !(0, _ramda.isNil)(this.props.fund.shareClass.performanceReturns) && this.props.fund.shareClass.renderPerformanceCard === true && (0, _ramda.includes)("SHOW_PERFORMANCE_CARD", this.props.fund.visibleData.formattingRules) && _react2.default.createElement(_performance_card2.default, {
          country: this.props.country,
          shareclass: this.props.fund.shareClass,
          historicalData: this.props.historicalData,
          breakpoint: this.props.breakpoint,
          activeTab: this.props.active,
          tabOrder: this.props.fund.visibleData.visiblePerformanceCardTabs,
          disclosure: this.props.fund.disclosures.pdpCardPerformance,
          largeTextDisclosure: this.props.fund.disclosures.pdpCardPerformanceLargeText })
      );
    }
  }]);

  return FundCommentary;
}(_react2.default.PureComponent);

exports.default = FundCommentary;